// extracted by mini-css-extract-plugin
export default {"category":"styles_category__u4mdl"};